import EdgeSourceAdditionalInfo from "./edgeSourceAdditionalInfo";
class EdgeSource extends EdgeSourceAdditionalInfo {
    constructor(EdgeId, From, To, FromGroup, ToGroup, MethodName, SourceTaskId) {
        super();
        this.Id = EdgeId;
        this.EdgeId = EdgeId;
        this.Source = From;
        this.Target = To;
        this.From = From;
        this.To = To;
        this.FromGroup = FromGroup;
        this.ToGroup = ToGroup;
        this.MethodName = MethodName;
        this.SourceTaskId = SourceTaskId;
    }
}
export const EDGE_SERVER_IGNORED_FIELDS = ["GroupId", "FromNodeName", "ToNodeName"];
export const EDGE_JSON_SERVER_IGNORED_FIELDS = ["Tag"];
export default EdgeSource;
